import { PressableProps } from 'react-native'

export type Status = 'default' | 'active' | 'disabled'

export interface OptionBadgeProps extends PressableProps {
  text: string
  status: Status
}

export const getStatusValue = (status: Status) => {
  switch (status) {
    case 'disabled':
      return -1
    case 'default':
      return 0
    case 'active':
      return 1
    default:
      return 0
  }
}
